import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 11.9547,
			cy: 12,
			rx: 11.9547,
			ry: 12,
			fill: "#F7F8F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5025 17H8.51622V15.5303L11.025 12.9941C11.7678 12.2331 12.2532 11.7067 12.4811 11.415C12.7089 11.1188 12.873 10.8454 12.9732 10.5947C13.0735 10.3441 13.1236 10.0843 13.1236 9.81543C13.1236 9.41439 13.012 9.11589 12.7887 8.91992C12.5699 8.72396 12.276 8.62598 11.9068 8.62598C11.5195 8.62598 11.1435 8.71484 10.7789 8.89258C10.4143 9.07031 10.0338 9.32324 9.63731 9.65137L8.48887 8.29102C8.98106 7.87174 9.38894 7.57552 9.71251 7.40234C10.0361 7.22917 10.3893 7.09701 10.7721 7.00586C11.1549 6.91016 11.5833 6.8623 12.0572 6.8623C12.6816 6.8623 13.233 6.97624 13.7115 7.2041C14.19 7.43197 14.5615 7.75098 14.8258 8.16113C15.0901 8.57129 15.2223 9.04069 15.2223 9.56934C15.2223 10.0296 15.1402 10.4626 14.9762 10.8682C14.8167 11.2692 14.566 11.6816 14.2242 12.1055C13.887 12.5293 13.29 13.1331 12.4332 13.917L11.1481 15.127V15.2227H15.5025V17Z",
			fill: "parent"
		})
	]
});
const ForwardRef = forwardRef(SvgTwoIcon);
export { ForwardRef as ReactComponent };
